export default "__VITE_ASSET__BdDgUWwn__"